/**
 * @format
 * @flow
 */
export const PASSWORD_TMEPLATE = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/i;
export const EMAIL_TEMPLATE = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;
export const AUTHCODE_TEMPLATE = /^(?=.*\d)[\d]{6}$/i;
export const INVALID_EMAIL = '無効なメールアドレス';
export const INVALID_AUTHCODE = '無効な認証コード';
export const INVALID_PASSWORD = '半角英数字（大文字・小文字・数字）8文字以上';
export const PASSWORD_NOT_MATCH = 'パスワードが一致しません。';
export const UNKNOWN_ERROR = '不明なエラー。';

// 0	募集中				 タスクを登録している状態
// 1	募集停止中			※今回はこのステータスは使わない
// 2	募集終了				タスク登録後、応募者を承認している状態
// 3	タスクルーのレビュー待ち							施設だけがレビューを完了した状態
// 4	完了						タスクルーがレビューを完了した状態
export const TS_CREATE = '0';
export const TS_CLOSED = '1';
export const TS_APPROVED = '2';
export const TS_WAIT_REVIEW = '3';
export const TS_COMPLETE = '4';
